import React from "react";
import moment from "moment";

// Components
import Table from "../../../component/table";
import DashboardPopOver from "../../../component/DashboardPopOver";
import { useDispatch } from "react-redux";

import {
  deleteWidgets,
  addToMyDashboard,
} from "../../../redux/actions/analytics";

const headers = [
  {
    headName: "Collaborator",
    isSort: false,
    value: "Collaborator",
  },

  {
    headName: "Last Login",
    isSort: false,
    value: "Last Login",
  },
];

function CollaboratorTable({
  title,
  menu,
  setUpdate,
  update,
  tab,
  isDisable,
  id,
  data,
}) {
  const dispatch = useDispatch();

  // Add To My Dashboard
  const handleAddToMyDashboard = () => {
    const request = {
      onError: (error) => {
        console.log(error);
      },
      onSuccess: () => {
        setUpdate(update + 1);
      },
      payload: {
        analytic_widget_id: id.analytic_widget_id,
      },
    };
    dispatch(addToMyDashboard(request));
  };

  // Delete Widget
  const handleDeleteWidgets = () => {
    const request = {
      dashboard_widget_id: id.analytic_dashboard_id,
      onError: (error) => {
        console.log(error);
      },
      onSuccess: () => {
        setUpdate(update + 1);
      },
    };
    dispatch(deleteWidgets(request));
  };

  return (
    <div className="w-full h-full">
      <div className="absolute top-1 right-2 text-base text-[#7D8490]">
        <DashboardPopOver
          menus={menu}
          handleOnClick={() =>
            tab ? handleDeleteWidgets() : handleAddToMyDashboard()
          }
          isDisable={isDisable}
        />
      </div>
      <div className="h-full w-full space-y-2">
        <h2 className="text-sm font-semibold text-[#313439] leading-5 ">
          {title}
        </h2>
        <div className="w-full h-[93%]">
          {data?.length > 0 ? (
            <div className="max-h-full max-w-full overflow-auto scrollbar scrollbar-w-2 scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar-thumb-gray-300 scrollbar-track-gray-100">
              <Table
                heads={headers}
                tClass="table-auto w-full border-separate border-spacing-y-2"
                hClass="text-[10px] leading-2 text-[#fff] !bg-[--bg-color-500] tracking-wide sticky top-0 first:text-left text-center"
                bClass="text-[10px] text-left"
                thClass={`h-[24px] whitespace-nowrap text-left font-semibold first:rounded-l last:rounded-r max-w-10 sticky top-0 pl-2 uppercase`}
              >
                {data.map((item, i) => {
                  return (
                    <tr
                      key={i}
                      className="whitespace-nowrap !bg-[#fff] h-9 !rounded"
                    >
                      <td className="pl-2">
                        <div className="h-full flex items-center space-x-3">
                          <div className="w-[22px] h-[22px] rounded bg-[--bg-color-500] text-[#fff] uppercase text-xs font-semibold flex justify-center items-center">
                            {item.name[0]}
                          </div>
                          <div className="max-w-full">
                            <h4
                              title={item.name}
                              className="text-[10px] text-[#535860] font-semibold max-w-full truncate"
                            >
                              {item.name}
                            </h4>
                            <h6
                              title={item.email}
                              className="text-[8px] font-medium text-[#535860]/50 max-w-full truncate"
                            >
                              {item.email}
                            </h6>
                          </div>
                        </div>
                      </td>
                      <td className="pl-2">
                        <div
                          title={
                            item.last_login
                              ? moment(item.last_login).format(
                                  "DD MMM, YYYY - HH:mm a"
                                )
                              : ""
                          }
                          className="text-[10px] font-medium text-[#535860] max-w-full truncate"
                        >
                          {item.last_login
                            ? moment(item.last_login).format(
                                "DD MMM, YYYY - HH:mm a"
                              )
                            : "Never logged in"}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </Table>
            </div>
          ) : (
            <div className="h-full flex justify-center items-center text-sm font-semibold leading-5 capitalize">
              No Data Found
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CollaboratorTable;
